import styled from 'styled-components'

import { media } from 'styles/media'

export const SecondaryHeading = styled.h2`
  line-height: 1.1;
  font-weight: 400;
  margin-bottom: 16px;
  text-align: center;

  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xl']?.['font-size']?.value};
  margin-top: 80px;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-size']?.value};
    margin-top: 120px;
  `}
`

export const Subheading = styled.p`
  line-height: 1.5;
  font-weight: 300;
  text-align: center;

  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-md']?.['font-size']?.value};

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xl']?.['font-size']?.value};
  `}
`

export const SpacingWrapper = styled.div`
  margin-top: 80px;

  ${media.md`
    margin-top: 120px;
  `}
`
